import { createFileRoute } from "@tanstack/react-router";
import WhyUs from "@/pages/WhyUs";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/why-us/")({
  head: () => routeHead("/uk/why-us/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <WhyUs />
  );
}
